import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "../services/projects/projects.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { MatDialog } from "@angular/material";
import { LayoutDialogComponent } from "../layout-dialog/layout-dialog.component";

@Component({
  selector: "app-build",
  templateUrl: "./build.component.html",
  styleUrls: ["./build.component.css"],
})
export class BuildComponent implements OnInit {
  @ViewChild("container") containerRef: ElementRef;
  project_id: string;
  project: any = [];
  unitTypes: any = [];
  projectBuldings: any;
  buildingDetailsForms: any = [];
  active: number = null;
  availableCount: number = 0;
  reservedCount: number = 0;
  activeProject: any = null;
  unit_type_id: number = null;
  floor_number: number = null;
  building_num: string = null;
  selectedBuilding: any = null;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));
  floors: any = [];
  units: any = [];

  constructor(
    private projectService: ProjectsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.project_id = params["id"];
      this.project_id && this.getcurrentproject(this.project_id);
      this.project_id && this.getProjectBuilding(this.project_id);
      this.project_id && this.getUnitTypesPerProject(this.project_id);
    });
  }

  getcurrentproject(project_id) {
    this.slimLoadingBarService.start();
    this.projectService.getcurrentproject(project_id).subscribe(
      (data) => {
        this.project = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getUnitTypesPerProject(project_id) {
    this.projectService.getUnitTypesPerProject(project_id).subscribe(
      (res) => {
        this.unitTypes = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getProjectBuilding(project_id) {
    this.slimLoadingBarService.start();
    this.projectService.getProjectBuilding(project_id).subscribe(
      (data: any) => {
        let status = [];
        data.map((building) => {
          Object.keys(building.status_counts).map((key) => {
            status.push({
              name: key,
              count: building.status_counts[key],
            });
          });
          building.status_counts = status;
          status = [];
        });
        this.projectBuldings = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  assignAvailableCount(project) {
    this.availableCount = 0;
    project.status_counts.map((key) => {
      if (key.name === "Available") {
        this.availableCount = key.count;
      }
    });
  }

  assignReservedCount(project) {
    this.reservedCount = 0;
    project.status_counts.map((key) => {
      if (key.name === "Reserved") {
        this.reservedCount = key.count;
      }
    });
  }

  viewUnitDetails(unit_id) {
    this.router.navigate(["./pages/projects/view-unit"], {
      queryParams: {
        project_id: this.project_id,
        unit_id: unit_id,
      },
    });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case "Available":
        return "available";
      case "Temp Blocked":
        return "temp-blocked";
      case "Blocked":
         return "blocked";
      case "Not Available":
        return "not-available";
      case "Re-pricing":
        return "re-pricing";
      default:
        return "reserved";
    }
  }

  getBuildingFloors(unit_type_id) {
    this.unit_type_id = unit_type_id;
    let qParams = {
      unit_type_id: unit_type_id,
      building_num: this.selectedBuilding.building_name,
    }

    this.slimLoadingBarService.start();
    this.projectService
      .getBuildingFloors(this.project_id, qParams)
      .subscribe(
        (res: any) => {
          this.floors = res.data;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  getBuildingDetails(floor) {
    this.floor_number = floor;
    let qParams = {
      unit_type_id: this.unit_type_id,
      floor_number: this.floor_number,
    };

    this.slimLoadingBarService.start();
    this.projectService
      .getBuildingDetails(this.project_id, this.selectedBuilding.building_name, qParams)
      .subscribe(
        (res: any) => {
          this.units = res.data;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  openLayoutDialog(unit: any) {
    this.dialog.open(LayoutDialogComponent, {
      width: "80vw",
      height: "95vh",
      data : unit
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/build/build.component.ts